import { Table, Input, Button, Modal, DatePicker,Select, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { httpGet, httpUrl, httpPost } from "../../api/httpClient";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ko_KR";
import excelPng from "../../img/excel.png";
import {comma} from "../../lib/util/numberUtil";
import { utils, writeFile } from "xlsx";
import { trSearchTypeCode } from "../../lib/util/codeUtil";
import SelectBox from "../../components/common/SelectBox";

const Search = Input.Search;
const { RangePicker } = DatePicker;
const now = new Date();

const TransferRequestList = () => {
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [type, setType] = useState(0);
    const [searchType, setSearchType] = useState("");
    const [selected, setSelected] = useState("ALL");
    const [searchText, setSearchText] = useState("");
    const [parentWalletInfo, setParentWalletInfo] = useState({});
    const [withdrawWalletInfo, setWithdrawWalletInfo] = useState({});
    const [transferRequestList, setTransferRequestList] = useState([]);
    const [date, setDate] = useState({
        start: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD")
      });
    const [selectedRow, setSelectedRow] = useState([]);
    const [checkAll, setCheckAll] = useState(false);

    const dte = 1000000000;

      useEffect(() => {
        getTransferRequestList();
    },[date.end, pagination.current, pagination.pageSize, searchText, date.start]);

    const getTransferRequestList = async () => {
        const pageSize = pagination.pageSize;
        const pageNum = pagination.current;
        const endDate = moment(date.end).add(1, 'd').format("YYYY-MM-DD")
        const res = await httpGet(httpUrl.transferRequestList, [ endDate, pageNum, pageSize, searchText, selected, date.start], {})
        if (!res) {
            console.log(`getListAsync failed. result: ${res.result}`);
            return;
        }
        setTransferRequestList(res.data.transferRequests);
        setPagination({
            ...pagination,
            current: res.data.currentPage,
            total: res.data.totalCount
        })
    };

    useEffect(()=>{
    },[])

    const handleTableChange = (page) => {
        if (page.current !== pagination.current) {
            setPagination({
                ...pagination,
                current: page.current
            });
        } else if (page.pageSize !== pagination.pageSize) {
            setPagination({
                ...pagination,
                current: 1,
                pageSize: page.pageSize
            });
        }
    };

    const columns = [
        {
            title: <div>
                <Checkbox
                    checked={checkAll}
                    onClick={async (e) => {
                        setCheckAll(!checkAll)
                        let checkList = []
                        if (!checkAll) {
                            for (let i = 0; i < transferRequestList.length; i++) {
                                await checkList.push(transferRequestList[i].idx)
                            }
                        }
                        setSelectedRow(checkList)
                    }}
                />
            </div>,
            dataIndex: "idx",
            className: "column-center",
            render: (data, row) => (
                <Checkbox
                    checked={selectedRow.filter(x => x === data).length > 0}
                    onClick={(e) => {
                        if (!e.target.checked) {
                            setSelectedRow(selectedRow.filter(x => x !== data));
                        } else {
                            let checkedData = [data]
                            setSelectedRow(selectedRow.concat(checkedData))
                        }
                    }}
                />
            ),
        },
        {
            title: "거래번호",
            dataIndex: "idx",
            className: "column-center",
        },
        {
            title: "신청번호(거래키)",
            dataIndex: "withdrawKey",
            className: "column-center",
        },
        {
            title: "일시",
            dataIndex: "createDate",
            className: "column-center",
            render: (data) => <div>{moment(data).format("YYYY-MM-DD HH:mm:ss")}</div>
        },
        {
            title: "유저키",
            dataIndex: "from",
            className: "column-center",
        },
        {
            title: "주소",
            dataIndex: "to",
            className: "column-center",
        },
        {
            title: "수량(USDT)",
            dataIndex: "amount",
            className: "column-center",
            render: (data) => <div>{comma(data/dte)}</div>
        },
        {
            title: "서브업체명",
            dataIndex: "subCompany",
            className: "column-center",
        },
        {
            title: "이메일",
            dataIndex: "email",
            className: "column-center",
        },
        {
            title: "휴대전화",
            dataIndex: "phone",
            className: "column-center",
        },
        {
            title: "IP주소",
            dataIndex: "ip",
            className: "column-center",
        },
        {
            title: "국가코드",
            dataIndex: "contryCode",
            className: "column-center",
        },
        {
            title: "처리",
            className: "column-center",
            render: (row) => (
                <Button
                onClick={() => notReady()}
                    // onClick={() => openDetailModal(row, true)}
                    // disabled={row.deleted ? true : false}
                >삭제</Button>
            )
        },
    ];
    const notReady =() =>{
        Modal.confirm({  
            title: "준비중입니다.",
            content: "해당 서비스는 준비중입니다.",
            okText: "확인",
            cancelText: " 취소",
        })
    }
    const onSearch = (value) => {
        setSearchText(value);
        getTransferRequestList();
    };

    const onSelect = (value) => {
        setSelected(value);
    };

    const reset =() =>{
        setType(0)
        setDate({
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
        setSearchText("")
        setSelected("ALL")
    };

    const changeDate =(type) =>{
    if (type ==='today'){
        setType(0)
        setDate({
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    } else if (type === 'week'){
        setType(1)
        setDate({
            start: moment().add(-7, 'd').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    }else if (type === 'threeMonth'){
        setType(2)
        setDate({
            start:  moment().add(-3, 'M').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    }else{
        setType(3)
        setDate({
            start: moment('2023-01-01').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
        }
    };

    const onChangeRangePicker = async (e, selectDate, value) => {
        setType(4)
        setDate({
            start: moment(selectDate[0]).format('YYYY-MM-DD'),
            end: moment(selectDate[1]).format('YYYY-MM-DD')
        })
    };

    const disabledDate = (current) => {
    return current && current > moment().endOf('day');
    };
    
    const onDownload = () => {
        httpGet(
            httpUrl.transferRequestListExcel,
            [
                moment(date.end).add(1, 'd').format("YYYY-MM-DD"), searchText, selected, date.start
            ],
            {}
        ).then((res) => {
            const excelJson = parseExcelJson(res.data.transferRequests);
            const ws = utils.json_to_sheet(excelJson, { skipHeader: true });
            const wb = utils.book_new();
            // ws["!cols"] = [];
            // ws["!cols"][2] = { width: 20 };
            // ws["!cols"][3] = { width: 15 };
            // ws["!cols"][4] = { width: 20 };
            // ws["!cols"][5] = { width: 15 };
            // ws["!cols"][8] = { width: 20 };
            utils.book_append_sheet(wb, ws, "sheet1");
            writeFile(wb, "출금_신청_내역.xlsx");
        });
      };
    
      const parseExcelJson = (data) => {
        let result = [
          {
            idx: '거래번호',
            withdrawKey: '신청번호',
            createDate: '일시',
            from: '유저키',
            to:'주소',
            amount:'입금할수량(USDT)',
            // subCompany:'서브업체명',
            // email:'이메일',
            // phone:'휴대전화',
            // ip:'IP주소',
            // countryCode:'국가코드'
          },
        ];
        data.forEach((item) => {
          result.push({
            idx: item.idx,
            withdrawKey: item.withdrawKey,
            createDate: moment(item.createDate).format("YYYY-MM-DD HH:mm:ss"),
            from: item.from,
            to: item.to,
            amount: comma(item.amount/dte) + `(USDT)`,
            // subCompany: item.subCompany,
            // email: item.email,
            // phone: item.phone,
            // ip: item.ip,
            // countryCode: item.countryCode,
          });
        });
    
        return result;
      };
    
    return (
        <div id= "TransferRequestList" className="main">
        <div className="main-title">
            출금 신청 내역
        </div>
        {/* <div className="bank-bar">
            <span>수수료 계좌 잔액 = 지불보증금(0.5 MATIC) 및 미출금 이용수수료(0 MATIC)를 제외한 수량</span>
            <div className="bank-box">
                <div>
                    집금계좌(USDT): 
                    <span>{parentWalletInfo.address}</span>
                </div>
                <div>
                    집금계좌 잔액: 
                    <span>0 USDT</span>
                </div>
            </div>
            <div className="bank-box">
                <div>
                수수료계좌(MATIC):
                <span> {withdrawWalletInfo.address}</span>
                </div>
                <div>
                수수료계좌 잔액: 
                <span> 0 MATIC </span>
                </div>
            </div>
        </div> */}
            <div className="top-bar">
                <div id="selectBox">
                    <Button className={type === 0 && "active"} onClick={()=>changeDate('today')}>
                        금일
                    </Button>
                    <Button  className={type === 1 && "active"} onClick={()=>changeDate('week')}>
                        1주일
                    </Button>
                    <Button className={type === 2 && "active"} onClick={()=>changeDate('threeMonth')}>
                        3개월
                    </Button>
                    <Button className={type === 3 && "active"} onClick={()=>changeDate('all')}>
                        전체
                    </Button>
                    <p>
                    <RangePicker
                     style={{
                        padding:5,
                        borderRadius:5,
                        marginRight:10,  
                        border:'1px solid #888',
                        height:32
                    }}
                        locale={locale}
                        format={"YYYY-MM-DD"}
                        allowClear={false}
                        picker="date"
                        value={[
                        moment(date.start, "YYYY-MM-DD"),
                        moment(date.end, "YYYY-MM-DD"),
                        ]}
                        onChange={onChangeRangePicker}
                        disabledDate={disabledDate}
                    />
                    </p>
                    <SelectBox
                        name="searchType"
                        className="memo-select" 
                        style={{width:100}}
                        placeholder={trSearchTypeCode['ALL']}
                        code={Object.keys(trSearchTypeCode)}
                        codeString={trSearchTypeCode}
                        onChange={(value) => {onSelect(value)}}
                        value={selected}
                    />
                     <Input.Search
                            placeholder="검색어를 입력하세요"
                            className="search-input"
                            enterButton
                            allowClear
                            onSearch={onSearch}
                            value={searchText}
                            onChange={(e:any)=>{
                                setSearchText(e.target.value.trim());
                            }}
                        />
                </div>
                <Button onClick={()=>reset()}>
                       초기화
                </Button>
            </div>
            <div className="top-table">
                <div className="top-table-container">
                    <div>
                        <div>
                            총 <span> {comma(pagination.total)}</span>건이 검색되었습니다.
                        </div>
                        <div>
                            최소 출금 수량 : <span> 1 </span> USDT
                            </div>
                            <div>
                            선택된 항목 : <span> 0 </span>개
                            </div>
                            <div>
                            선택 수량 합계 : <span> 0 </span>USDT
                            </div>
                    </div>        
                    <div>
                        <Button className="check-btn"
                            onClick={() => notReady()}
                        > 
                        <div>
                            검증
                        </div>
                        </Button>
                        <Button className="check-btn"
                            onClick={() => notReady()}
                        > 
                        <div>
                            출금
                        </div>
                        </Button>
                        <Button className="check-btn"
                            onClick={() => notReady()}
                        > 
                        <div>
                            로그
                        </div>
                        </Button>
                        <Button className="download-btn"
                            onClick={() => onDownload()}
                        > 
                        <div>
                            <img src={excelPng} alt="" />다운로드
                        </div>
                        </Button>
                        </div>
                    </div>

                <Table
                    rowKey={(record) => record.idx}
                    dataSource={transferRequestList}
                    columns={columns}
                    pagination={pagination}
                    onChange={handleTableChange}
                />
                </div>
        </div>
    );

}

export default TransferRequestList;
